import { FC, useRef } from 'react';
import { Collapse } from 'react-bootstrap';
import { Close, MagnifyingGlass } from 'src/assets/images/Svgs/svg';
import styles from 'src/Features/Menu/menu.module.scss';
import { useAppSelector } from 'src/redux/store/store';

const ItemSearch: FC<any> = (props) => {
  const { targetState, setTargetState, searchHandle, clearSearch, SearchShow } =
    props;
  const emailInput = useRef(null);
  const isCheckLiveTrackBar = useAppSelector(
    (state) => state.checkout.orderTrack,
  );

  setTimeout(() => emailInput?.current?.focus(), 0);
  return (
    <>
      <div>
        <Collapse in={SearchShow}>
          <div id="example-collapse-text">
            <div
              className={`${styles.searchBarWrapper} ${
                isCheckLiveTrackBar && styles.isLiveOrderBarShow
              }`}
            >
              <div
                className={`${styles.searchInnerWrap} w-100 d-flex bg-white`}
              >
                <button
                  type="button"
                  className={`${styles.search_btn} btn f-s0`}
                >
                  <MagnifyingGlass width={29} height={29} />
                </button>
                <div
                  className={`${styles.search_inn_content} d-flex align-items-center`}
                >
                  <span className={styles.search_bar_icon}></span>
                  <input
                    type="text"
                    className={`${styles.form_control} form-control`}
                    placeholder="Search"
                    ref={emailInput}
                    autoFocus={true}
                    value={targetState}
                    onChange={(e) => setTargetState(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && searchHandle()}
                  />
                  <button
                    type="button"
                    className={`${styles.search_result_btn} btn-small red text-uppercase f-s16 mw-auto mx-content py-1 px-3 d-none d-md-block`}
                    onClick={searchHandle}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className={`${styles.search_close_btn} btn`}
                    onClick={() => {
                      searchHandle();
                      clearSearch();
                    }}
                  >
                    <Close />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </>
  );
};
export default ItemSearch;
